import { Container } from "flux/utils";
import * as React from "react";
import { Fixture } from "../fixtures/records/Fixture";
import { ACTION_TYPE } from "./Actions";
import Dispatcher from "./Dispatcher";
import FixtureDetailedStore, { MatchData } from "./stores/FixtureDetailedStore";
import { FixtureDetailedView, FixtureDetailedViewProps } from "./view/FixtureDetailedView";
import { FixtureScoreboardErrorBoundary } from "./view/FixtureScoreboardErrorBoundary";

export interface Props {
  id: number;
  summary: Fixture; // Only a fixture sumamry
  legacy: boolean;
  isAdmin: boolean;
  displaySelf: () => void
}

class FixtureScoreboardContainer extends React.Component<Props, FixtureDetailedViewProps> {
  public componentWillMount() {
    FixtureDetailedStore.configure({legacy: this.props.legacy});
    if(this.props.summary.status === "Started" || this.props.summary.status === "Ended") {
      Dispatcher.dispatch({
        type: ACTION_TYPE.FIXTURE_START_LOAD,
        id: this.props.id,
      });
    }
  }

  public componentDidUpdate(prevProps : Props, prevState) {
    if(prevProps.summary.status === "Scheduled" && (this.props.summary.status === "Started" || this.props.summary.status === "Ended")) {
        this.props.displaySelf();
        Dispatcher.dispatch({
          type: ACTION_TYPE.FIXTURE_START_LOAD,
          id: this.props.id,
        });
    }
  }

  public componentWillUnmount() {
    Dispatcher.dispatch({
      type: ACTION_TYPE.LIVE_DATA_UNSOCKET,
      id: this.props.id,
    });
  }

  public render(): React.ReactElement<any> {
    return (
      <FixtureScoreboardErrorBoundary>
        {(this.props.summary.status === "Started" || this.props.summary.status === "Ended") && <FixtureDetailedView {...this.state} />}
      </FixtureScoreboardErrorBoundary>
    );
  }

  public static getStores(): any[] {
    return [FixtureDetailedStore];
  }

  public static calculateState(prevState: Props, props: Props): FixtureDetailedViewProps {
    return {
      id: props.id,
      fixtureLoader: FixtureDetailedStore.getState().getLoadObject(),
      legacy: props.legacy,
      isAdmin: props.isAdmin
    };
  }
}

export default Container.create(FixtureScoreboardContainer, { withProps: true });